import React from "react"
import moment from 'moment'
import { Table, Divider, Space, Button, Pagination, Modal, message, Row, Col } from "antd"
import { Link } from "react-router-dom"

import { AdminService } from "@/services"
import CommonLayout from "@/common/Layout"

import GroupEditFormModal from "./editFormModal"

class PublicComponentGroupsPage extends React.PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      ready: false,
      groupList: [],
      isCreating: false,
      editingGroup: null
    }
  }

  async componentDidMount() {
    this.refreshGroupList()
  }

  async refreshGroupList() {
    const params = { page: 1, page_size: 5000 }
    const response = await AdminService.get_public_component_group_list(params)

    const dataBody = response.data.body

    this.setState({
      ready: true,
      groupList: dataBody.groups
    })
  }

  async handleSubmitCreateGroup(formData) {
    console.log("todo handleSubmitCreateGroup", formData)

    const params = {
      key: formData.key,
      name: formData.name
    }
    const response = await AdminService.create_public_component_group(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("创建失败，请稍后重试！")
    }

    this.refreshGroupList()
    this.setState({ isCreating: false })

    message.success("保存成功")
  }

  async handleSubmitUpdateGroup(groupId, formData) {
    console.log("todo handleSubmitUpdateGroup", groupId, formData)

    const params = {
      group_id: groupId,
      key: formData.key,
      name: formData.name,
      order_score: formData.orderScore
    }

    const response = await AdminService.update_public_component_group(params)

    const { status, body } = response.data
    if (status <= 0) {
      return message.error("保存失败，请稍后重试！")
    }

    this.refreshGroupList()
    this.setState({ editingGroup: null })

    message.success("保存成功")
  }

  handleClickDeleteGroup(group) {
    Modal.confirm({
      title: `确认要删除分组"${group.name}"吗？`,
      content: '删除后将不可恢复，请谨慎操作',
      okText: "确认",
      cancelText: "取消",
      onOk: async () => {
        console.log("todo deleteGroup", group)
        const params = {
          group_id: group.id
        }

        const response = await AdminService.delete_public_component_group(params)
        const { status, body } = response.data
        if (status <= 0) {
          return message.error("删除失败，请稍后重试！")
        }

        this.refreshGroupList()
        message.success("删除成功")
      }
    })
  }

  renderNewModal() {
    const { isCreating } = this.state
    if (!isCreating) return null

    const formData = {}

    return (
      <GroupEditFormModal
        isNew={true}
        title="新建分组"
        formData={formData}
        onCancel={() => this.setState({ isCreating: false })}
        onSubmit={(formData) => this.handleSubmitCreateGroup(formData)}
      />
    )
  }

  renderEditModal() {
    const { editingGroup } = this.state
    if (!editingGroup) return null

    return (
      <GroupEditFormModal
        isNew={false}
        title="编辑分组"
        formData={editingGroup}
        onCancel={() => this.setState({ editingGroup: null })}
        onSubmit={(formData) => this.handleSubmitUpdateGroup(editingGroup.id, formData)}
      />
    )
  }

  renderGroupsTable() {

    const { groupList } = this.state

    const columns = [
      {
        title: '分组名称',
        dataIndex: 'name',
        key: 'name',
        align: "center"
      },
      {
        title: "分组标识",
        dataIndex: "key",
        key: "key",
        align: "center"
      },
      {
        title: '排序值',
        dataIndex: 'orderScore',
        key: 'orderScore',
        align: "center"
      },
      {
        title: '操作',
        key: 'action',
        align: "center",
        render: (text, record) => (
          <Space>
            <Link to={`/publicComponents/groupComponents?groupId=${record.id}`} tag="a">
              <span style={{ display: "inline-block" }}>组件列表</span>
            </Link>
            <Divider type="vertical" />
            <a onClick={() => this.setState({ editingGroup: record })} style={{ display: "inline-block" }}>编辑</a>
            <Divider type="vertical" />
            <a onClick={() => this.handleClickDeleteGroup(record)} style={{ display: "inline-block" }}>删除</a>
          </Space>
        )
      },
    ];

    return (
      <Table
        dataSource={groupList}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
    )
  }

  render() {
    return (
      <CommonLayout selectedMenuKey="publicComponentsGroups" openMenuKeys={["groupPublicComponents"]}>
        <Row>
          <Col span={16}>
            <h2>组件分组</h2>
          </Col>
          <Col span={8} style={{ textAlign: "right" }}>
            <Button type="primary" onClick={() => this.setState({ isCreating: true })}>新建分组</Button>
          </Col>
        </Row>

        <div style={{ marginBottom: 20 }}>
          {this.renderGroupsTable()}
        </div>

        {this.renderNewModal()}
        {this.renderEditModal()}
      </CommonLayout>
    )
  }
}

export default PublicComponentGroupsPage
